import { useState } from "react";
// api services
import apiParticipantes from "../api/Participantes/api-participantes";
// redux
import { useDispatch, useSelector } from "react-redux";
import {
  guardarDatosPostulacion,
  tipoParticipante,
} from "../redux/actions/participantesAction";
import { useNavigate } from "react-router";
import { RootState } from "../redux/reducers";
import apiConvocatorias from "../api/Convocatorias/api-convocatorias";
import { useEncrypt } from "./useEncrypt";
import getStorageUser from "../middlewares/GetStorageUser"

export const useSeleccionarRoles = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [principalState, setPrincipalState] = useState(initialValues);

  const { decrypt, encrypt } = useEncrypt();
  const { datos_postulacion } = useSelector(
    (state: RootState) => state.participantes
  );

  /**
   * Deja la postulacion lista para el perfil elegido: la crea si todavia no
   * existe y guarda el tipo de participante en el registro.
   *
   * El wizard hace lo mismo sin cambiar de pantalla, asi que la navegacion
   * al formulario del perfil es opcional.
   */
  const asociarRoles = async (
    tipo_participante: number,
    opciones: { navegar?: boolean } = {}
  ) => {
    const { navegar = true } = opciones;
    const id_postulacion = localStorage.getItem("id_postulacion");
    localStorage.setItem(
      "tipo_participante_postulacion",
      `${tipo_participante - 1}`
    );
    //Se resta uno debido a que los documentos evaluan a los tipos de participantes del 0 al 2 y no del 1 al 3 como al momento del registro
    if (id_postulacion == null) {
      console.log('entroo id postulacion null')
      if (!getStorageUser()) {
        navigate('/login');
        return;
      }
      const user = getStorageUser()
      dispatch(tipoParticipante(tipo_participante));
      dispatch(
        guardarDatosPostulacion({
          ...datos_postulacion,
          tipo_participante,
          principalState,
        })
      );
      const { data: convocatoria } = await apiConvocatorias.infoConvocatoria(
        decrypt(localStorage.getItem("idConvocatoriaPostulacion"))
      );

      let payload = {
        convocatoria_id: decrypt(
          localStorage.getItem("idConvocatoriaPostulacion")
        ),
        numero_documento_participante: user.documento,
        linea_convocatoria: convocatoria[0].linea_convocatoria,
        secuencia: convocatoria[0].sec,
        tipo_participante: tipo_participante,
        documentos_administrativos: convocatoria[0].documentos_administrativos,
        documentos_tecnicos: convocatoria[0].documentos_tecnicos,
        estado: "Por guardar",
        tipo: 1,
      };

      const validatePostulacion = await apiParticipantes.validarPostulacion(Number(decrypt(localStorage.getItem("idConvocatoriaPostulacion"))), user?.documento?.toString());

      if (validatePostulacion?.data == null) {
        console.log('entroo al validatePostulacion')

        let { data } = await apiParticipantes.crearPostulacion(payload);

        if (data) {
          localStorage.setItem(
            "id_postulacion",
            encrypt(data.id_postulacion.toString())
          );
        }
      }
    }

    console.log('entroo con id postulacion')

    // Obtener y desencriptar id_postulacion del localStorage
    const id_postulacion_encrypted = localStorage.getItem("id_postulacion");
    if (id_postulacion_encrypted) {
      const id_postulacion_decrypt = decrypt(id_postulacion_encrypted);
      if (id_postulacion_decrypt) {
        await apiParticipantes.actualizarTipoPById(
          parseInt(id_postulacion_decrypt),
          tipo_participante.toString()
        );
      }
    }

    if (!navegar) return;

    if (tipo_participante === 1) {
      return navigate("/Usuario/Personanatural/");
    }
    if (tipo_participante === 2) {
      return navigate("/Usuario/Personajuridica/");
    }
    if (tipo_participante === 3) {
      return navigate("/Usuario/Grupoconformado/");
    }
  };

  const cambioCheckBox = (e: any, input: string) => {
    console.log(e);
    //
    // //console.log(e.target.value)
    setPrincipalState({
      ...principalState,
      [input]: e.target.checked,
    });
  };

  const atras = () => {
    return navigate("/verconvocatoria");
  };

  return {
    principalState,
    setPrincipalState,
    asociarRoles,
    cambioCheckBox,
    atras,
  };
};

const initialValues = {
  Gestor: true,
  Creador: false,
  tipo_participante: null,
};
